import * as React from "react";
import { Bar, BarChart, Legend, Tooltip, XAxis, YAxis } from "recharts";
import { useSortedByCategory } from "../../../Helper/CategorySortHelper";

const ServiceableServiceLevelBarChartComponent = ({ data }) => {
  const calculateYAxisMax = () => {
    return 100;
  };

  // 1. Performanslı sıralama için hook kullan
  const sortedData = useSortedByCategory(data || [], "category");

  // 2. Hesaplamaları uygula (sıralama sonrası)
  const processedData = sortedData.map(item => {
    // Toplam hesapla
    const total = (item.onTime || 0) + (item.delayed || 0);

    // Service Level yüzdesini hesapla (onTime/total * 100, 2 ondalık)
    const calculatedServiceLevel = total > 0 ? parseFloat((((item.onTime || 0) / total) * 100).toFixed(2)) : 0;

    // ServiceLevelValue'dan serviceLevel'ı çıkar, delayPercent'i bul
    const serviceLevelValue = item.serviceLevelValue || item.ServiceLevelValue || 0;

    // DelayPercent'i her zaman hesapla: serviceLevelValue - serviceLevel
    let delayPercent = serviceLevelValue - calculatedServiceLevel;

    // Negatif değerleri 0'a çek (serviceLevel > serviceLevelValue durumunda)
    if (delayPercent < 0) {
      delayPercent = 0;
    }

    // Küçük değerleri görünür hale getir
    const minVisibleValue = 2;
    const displayServiceLevel =
      calculatedServiceLevel > 0 && calculatedServiceLevel < minVisibleValue ? minVisibleValue : calculatedServiceLevel;
    const displayDelayPercent = delayPercent > 0 && delayPercent < minVisibleValue ? minVisibleValue : delayPercent;

    return {
      ...item,
      // contractName zaten item içinde geliyor, tekrar eklemeye gerek yok
      serviceLevel: displayServiceLevel,
      delayPercent: displayDelayPercent,
      // Orijinal değerleri tooltip için sakla
      originalServiceLevel: calculatedServiceLevel,
      originalDelayPercent: delayPercent,
      // Debug için
      total,
      serviceLevelValue,
    };
  });

  // Custom Tooltip Component
  const CustomTooltip = ({ active, payload }: any) => {
    if (!active || !payload?.[0]) return null;

    const data = payload[0].payload;

    return (
      <div
        style={{
          backgroundColor: "white",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "10px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#333' }}>
                    {data.contractName}
                </p> */}
        <p style={{ margin: "4px 0", color: "#666" }}>
          Category: <strong>{data.category}</strong>
        </p>
        <p style={{ margin: "4px 0", color: "#45B4C8" }}>
          Service Level: <strong>{data.originalServiceLevel}%</strong>
        </p>
        <p style={{ margin: "4px 0", color: "#FF0000" }}>
          Delay Level: <strong>{data.originalDelayPercent}%</strong>
        </p>
      </div>
    );
  };

  return (
    <>
      <BarChart width={900} height={600} data={processedData} margin={{ top: 60, right: 50, left: 50, bottom: 140 }}>
        <XAxis
          type="category"
          dataKey="category"
          angle={-45}
          textAnchor="end"
          height={140}
          interval={0}
          tick={{ fontSize: 12 }}
        />
        <YAxis type="number" domain={[0, calculateYAxisMax()]} tickFormatter={value => `${value}%`} />
        <Tooltip cursor={false} content={<CustomTooltip />} />
        <Legend
          verticalAlign="top"
          height={36}
          payload={[
            { value: "Service Level", type: "line", id: "serviceLevel", color: "#45B4C8" },
            { value: "Delay Level", type: "line", id: "delayPercent", color: "#FF0000" },
          ]}
        />
        <Bar dataKey="serviceLevel" stackId="a" fill="#45B4C8" isAnimationActive={false} barSize={30} />
        <Bar dataKey="delayPercent" stackId="a" fill="#FF0000" isAnimationActive={true} barSize={30} />
      </BarChart>
    </>
  );
};

export default ServiceableServiceLevelBarChartComponent;
